export default {
  name: 'Sidebar',
  displayName: {
    en: 'Sidebar',
    ja: 'サイドバー',
  },
  defaultWidth: 256,
  defaultHeight: 100,
  resizeX: true,
  screens: {
    desktop: {
      width: 262,
      height: 791,
    },
    tablet: {
      width: 262,
      height: 1022,
    },
    mobile: {
      width: 262,
      height: 667,
    },
  },
  props: [
    {
      name: 'menuListActions',
      type: 'action',
      displayName: {
        en: 'Menu List Actions',
        ja: 'メニューリストアクション',
      },
      reference: 'items',
    },
  ],
  childComponents: [
    {
      name: 'logo',
      displayName: {
        en: 'Logo',
        ja: 'Logo',
      },
      props: [
        {
          name: 'imageLogo',
          displayName: {
            en: 'Image Source',
            ja: '画像ソース',
          },
          type: 'image',
          default: [],
        },
        {
          name: 'enabled',
          type: 'boolean',
          default: true,
        },
      ],
    },
    {
      name: 'menuList',
      displayName: {
        en: 'Menu Lists',
        ja: 'Menu Lists',
      },
      props: [
        {
          name: 'items',
          displayName: {
            en: 'Menu Items',
            ja: 'メニュー項目',
          },
          type: 'dynamicListIcon',
          default: [
            {
              id: 'menu-group',
              text: 'メニー',
              type: 'group',
              children: [
                { id: 'home', text: 'ホーム', icon: 'home', type: 'item' },
                { id: 'list', text: '一覧', icon: 'list', type: 'item' },
                {
                  id: 'favorites',
                  text: 'お気に入り',
                  icon: 'star',
                  type: 'item',
                },
              ],
            },
            {
              id: 'mypage-group',
              text: 'マイページ',
              type: 'group',
              children: [
                {
                  id: 'profile',
                  text: 'プロフィール',
                  icon: 'person',
                  type: 'item',
                },
                {
                  id: 'notifications',
                  text: '通知',
                  icon: 'notifications',
                  type: 'item',
                },
                {
                  id: 'settings',
                  text: '設定',
                  icon: 'settings',
                  type: 'item',
                },
              ],
            },
            {
              id: 'other-group',
              text: 'その他',
              type: 'group',
              children: [
                {
                  id: 'logout',
                  text: 'ログアウト',
                  icon: 'logout',
                  type: 'item',
                },
                {
                  id: 'help',
                  text: 'ヘルプページ',
                  icon: 'help',
                  type: 'item',
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  resizeY: true,
  style: {
    backgroundColor: true,
    text: true,
    color: true,
    activeColor: true,
    hoverColor: true,
    zIndex: true,
  },
};
